import { observable, computed, action, toJS } from "mobx";
import isFunction from "lodash/isFunction";
import isEmpty from "lodash/isEmpty";
import forEach from "lodash/forEach";

class TableRowModel {
    @observable rowData;
    @observable toggledColumns;

    constructor(data) {
        this.rowData = observable.map(data);
        this.toggledColumns = observable.map({});
    }

    @computed
    get data() {
        if (isEmpty(this.toggledColumns)) {
            return this.rowData;
        }

        // patching in old functionality to expose toggled status
        const data = new Map(this.rowData);
        forEach(toJS(this.toggledColumns), (isToggled, columnName) => {
            if (isToggled) {
                data.set(`show-${columnName}`, true);
            }
        });

        return data;
    }

    @action
    toggleColumn(columnName, loadDataFunction) {
        if (!this.rowData.get(columnName) && isFunction(loadDataFunction)) {
            loadDataFunction(() => {
                this.toggledColumns.set(columnName, true);
            });
        } else {
            this.toggledColumns.set(columnName, !this.toggledColumns.get(columnName));
        }
    }
}

export default TableRowModel;
